export default __webpack_public_path__ + "fonts/iconfont.fdd648ad15e5c5363d87f2662391ef65.woff";